import { render, staticRenderFns } from "./News_arch.vue?vue&type=template&id=3967e256&scoped=true"
import script from "./News_arch.vue?vue&type=script&lang=js"
export * from "./News_arch.vue?vue&type=script&lang=js"
import style0 from "./News_arch.vue?vue&type=style&index=0&id=3967e256&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967e256",
  null
  
)

/* custom blocks */
import block0 from "./News_arch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports